import React, { createContext, useContext, useEffect, useState } from 'react';

// Create the context
const BaseUrlContext = createContext();

// Create a custom hook to use the context
export const useBaseUrlContext = () => {
    return useContext(BaseUrlContext);
};

// Create a provider component
export const BaseUrlProvider = ({ children }) => {

    // You can set your base URL here
    //const baseUrl = 'http://localhost:8080/v1/api/skillsource';
    const [baseUrl, setBaseUrl] = useState('https://api.talentscoutai.app/v1/api/skillsource');

  useEffect(()=> {
    console.log('location', window.location.hostname)
    const domain = window.location.hostname;

    if(domain === "localhost"){
      setBaseUrl("https://api.talentscoutai.app/v1/api/skillsource")
    }
    else{
      setBaseUrl("https://api.talentscoutai.app/v1/api/skillsource")
    }
    
  },[])
  
  return (
    <BaseUrlContext.Provider value={{ baseUrl }}>
      {children}
    </BaseUrlContext.Provider>
  );
};